export default {
	label: 'Settings',
	adminRightsAreMissing: 'Admin rights are missing!',
	customFieldsRights: 'Custom fields view is not available in "All institutions" view!',
	EITS: 'Estonian Information Security Standard (E-ITS)',
	RIA: 'State Information System (RIA)',
	CC: 'CC BY 4.0',
	version: 'Version',
	backup: {
		tab: 'Backup',
		description: 'Download a full database backup for migrating this installation to Cybsis 2.0.',
		download: 'Download backup',
	},
}
